export interface IPaged
{
    PageSize:number;
    Page:number;
    PageCount:number;
    TotalRows:number;
}
export interface IServiceResponse
{
    StatusCode:number;
    StatusDescription:string;
    Status:number;
    hasMessage:boolean;
    Messages:any;
    UserMessage:string;
    Response:any;
    FileName:string;
    OtherResponse:string;
    ContentFail:string;
    Paged:IPaged,
    getResponse():any;    
}
export class ServiceResponse implements IServiceResponse
{
    constructor(data?: any)
    {
        Object.assign(this, data);        
    }
    public StatusCode = 0;
    public StatusDescription='';
    public Status = 0;
    public hasMessage = false;
    public Messages=null;
    public UserMessage="";
    public Response = null;
    public FileName = '';
    public OtherResponse='';
    public ContentFail='';
    public Paged = {
        PageSize:0,
        Page:0,
        PageCount:0,
        TotalRows:0,
    };
    public getResponse():any
    {
        return this.Response;
    }    
}